module.exports = __webpack_public_path__ + "x2.no1.3420683d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/x2.no1.jpg
// module id = 7sLb
// module chunks = 0